function CalculateResults({ children }) {
  return <div className="border-b border-gray-300 divide-y divide-gray-300">{children}</div>
}

export default CalculateResults
